const productionConfig = {
  KEYSTONE_REDIRECT_URL: 'https://lmsedit.brightmls.com/Keystone/index.html',
  NGW_REDIRECT_URL: '/overview',
  KEYSTONE_PREVIEW_URL:
    'https://lmsedit.brightmls.com/Keystone/index.html#ListingPreview:',
  MAPS_API_KEY: 'AIzaSyBzT2RIc0aRLMKM332nSgzxXrw_8wzz9Gk',
  MAP_ID: '5ddf98242be82539',
  SERVICE_MENU_BASE: 'https://menu.brightmls.com/assets/menu',
  SERVICE_KEY_APP_SERVICE: 'https://aue1p1lmsedit2.brightmls.com/KeyAppSvc',
  FRONTEND_URL: 'https://lae.brightmls.com',
  LOGOUT_URL: 'https://www.brightmls.com/logout',
  INACTIVE_TIME: 7200000,
  AUTOSAVE_INTERVAL: 60000,
  IS_AI_ASSISTANT_ENABLED: true,
  FLAGSMITH_API_KEY: 'hLWSNjPJ8ZfPrpUkSANCxx',
  RESO_BASE_URL: 'https://bright-reso-update.brightmls.com/RESO',
  TIMEZONE: 'America/New_York',
  AI_DESCRIPTION_LENGTH: 40,
  AI_DESCRIPTION_OFFSET: 10,
  SHOWING_CHOICE_SERVICE_URL:
    'https://agl1p1z1showingchoiceservices.prd.brightmls.com',
  SHOWING_CHOICE_SETTINGS_URL: 'https://showing.brightmls.com/showingchoice',
  TAX_SEARCH_THRESHOLD: 3,
  MATRIX_LISTING_URL: 'https://matrix.brightmls.com/matrix/link/Listing?id=',
  RESO_TENANT_NAME: 'bright',
  RESO_RESOURCE_PAGE_SIZE: 500,
  BADGE_ERROR_HIGHLIGHT_TIME: 2500,
  LOCAL: false,
  WS_URL: 'wss://ws-laeservices.prd.brightmls.com', // Configure prod with .prd subdomain
  RESO_DEBUG_MODE: false,
};

const testConfig = {
  KEYSTONE_REDIRECT_URL:
    'https://lmsedit.tst.brightmls.com/Keystone/index.html',
  NGW_REDIRECT_URL: '/overview',
  KEYSTONE_PREVIEW_URL:
    'https://lmsedit.tst.brightmls.com/Keystone/index.html#ListingPreview:',
  MAPS_API_KEY: 'AIzaSyBzT2RIc0aRLMKM332nSgzxXrw_8wzz9Gk',
  MAP_ID: '5ddf98242be82539',
  SERVICE_MENU_BASE: 'https://menu.tst.brightmls.com/assets/menu',
  SERVICE_KEY_APP_SERVICE: 'https://aue1t1lmsedit2.dev.brightmls.com/KeyAppSvc',
  FRONTEND_URL: 'https://lae.tst.brightmls.com',
  AUTOSAVE_INTERVAL: 60000,
  LOGOUT_URL: 'https://www.tst.brightmls.com/logout',
  INACTIVE_TIME: 7200000,
  IS_AI_ASSISTANT_ENABLED: true,
  FLAGSMITH_API_KEY: 'ASJwxPh7AkqogQkogwivSu',
  RESO_BASE_URL: 'https://bright-reso-update.tst.brightmls.com/RESO',
  TIMEZONE: 'America/New_York',
  AI_DESCRIPTION_LENGTH: 40,
  AI_DESCRIPTION_OFFSET: 10,
  SHOWING_CHOICE_SERVICE_URL:
    'https://agl1t1z1showingchoiceservices.tst.brightmls.com',
  SHOWING_CHOICE_SETTINGS_URL:
    'https://showing.tst.brightmls.com/showingchoice',
  TAX_SEARCH_THRESHOLD: 3,
  MATRIX_LISTING_URL:
    'https://matrix.tst.brightmls.com/matrix/link/Listing?id=',
  RESO_TENANT_NAME: 'bright',
  RESO_RESOURCE_PAGE_SIZE: 500,
  BADGE_ERROR_HIGHLIGHT_TIME: 2500,
  LOCAL: false,
  WS_URL: undefined,
  RESO_DEBUG_MODE: false,
};

const devConfig = {
  KEYSTONE_REDIRECT_URL:
    'https://lmsedit.dev.brightmls.com/Keystone/index.html',
  NGW_REDIRECT_URL: '/overview',
  KEYSTONE_PREVIEW_URL:
    'https://lmsedit.dev.brightmls.com/Keystone/index.html#ListingPreview:',
  MAPS_API_KEY: 'AIzaSyBzT2RIc0aRLMKM332nSgzxXrw_8wzz9Gk',
  MAP_ID: '5ddf98242be82539',
  AUTOSAVE_INTERVAL: 60000,
  SERVICE_MENU_BASE: 'https://menu.dev.brightmls.com/assets/menu',
  SERVICE_KEY_APP_SERVICE: 'https://aue1d1lmsedit2.dev.brightmls.com/KeyAppSvc',
  LOGOUT_URL: 'https://www.dev.brightmls.com/logout',
  INACTIVE_TIME: 7200000,
  IS_AI_ASSISTANT_ENABLED: true,
  FLAGSMITH_API_KEY: 'LwVF8WmPC5UQmRWhqZz5ck',
  RESO_BASE_URL: 'https://bright-reso-update.dev.brightmls.com/RESO',
  TIMEZONE: 'America/New_York',
  AI_DESCRIPTION_LENGTH: 40,
  AI_DESCRIPTION_OFFSET: 10,
  SHOWING_CHOICE_SERVICE_URL:
    'https://agl1d1z1showingchoiceservices.dev.brightmls.com',
  SHOWING_CHOICE_SETTINGS_URL:
    'https://showing.dev.brightmls.com/showingchoice',
  TAX_SEARCH_THRESHOLD: 3,
  MATRIX_LISTING_URL:
    'https://matrix.dev.brightmls.com/matrix/link/Listing?id=',
  RESO_TENANT_NAME: 'bright',
  RESO_RESOURCE_PAGE_SIZE: 500,
  BADGE_ERROR_HIGHLIGHT_TIME: 2500,
  LOCAL: false,
  WS_URL: undefined,
  RESO_DEBUG_MODE: false,
};

export const localConfig = {
  ...devConfig, // Inherit from dev config since they're very similar
  TIMEZONE: 'America/New_York',
  API_URL: process.env.REACT_APP_API_URL || undefined,
  WS_URL: undefined,
  LOCAL: true,
};

const getEnvironmentFromHostname = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('laelocal.') || hostname.includes('addeditlocal.')) {
    return 'local';
  }
  if (hostname.includes('.tst.')) {
    return 'test';
  }
  if (hostname.includes('.dev.')) {
    return 'development';
  }
  return 'production';
};

const getConfigForEnvironment = (env: string) => {
  switch (env) {
    case 'local':
      return localConfig;
    case 'test':
      return testConfig;
    case 'development':
      return devConfig;
    case 'production':
    default:
      return productionConfig;
  }
};

// Get the current environment
const currentEnvironment = getEnvironmentFromHostname();
const config = getConfigForEnvironment(currentEnvironment);

// Export all configuration values
export const {
  KEYSTONE_REDIRECT_URL,
  NGW_REDIRECT_URL,
  KEYSTONE_PREVIEW_URL,
  MAPS_API_KEY,
  MAP_ID,
  SERVICE_MENU_BASE,
  LOGOUT_URL,
  AUTOSAVE_INTERVAL,
  INACTIVE_TIME,
  IS_AI_ASSISTANT_ENABLED,
  FLAGSMITH_API_KEY,
  AI_DESCRIPTION_LENGTH,
  AI_DESCRIPTION_OFFSET,
  RESO_BASE_URL,
  LOCAL,
  TIMEZONE,
  SHOWING_CHOICE_SERVICE_URL,
  SHOWING_CHOICE_SETTINGS_URL,
  TAX_SEARCH_THRESHOLD,
  RESO_TENANT_NAME,
  RESO_RESOURCE_PAGE_SIZE,
  WS_URL,
  MATRIX_LISTING_URL,
  BADGE_ERROR_HIGHLIGHT_TIME,
  RESO_DEBUG_MODE,
} = config;

// For debugging purposes
export const getCurrentEnvironment = () => currentEnvironment;
